<template>
  <div>
    <div class="personal">
      <div class="nav">
        <div class="ban">
          <ul class="nav-top">
<!--            <li class="yinyou">-->
<!--              &lt;!&ndash; <i class="img">我的会员</i> &ndash;&gt;-->
<!--              <span class="myMember">订单中心</span>-->
<!--            </li>-->
            <li v-for="item in tabList" :key="item.id" @click="changes(item)">
              <span>{{ item.text }}</span>
              <i :class="checked === item.id ? 'checked' : ''"></i>
            </li>
          </ul>
        </div>
      </div>
      <div class="ban">
<!--        &lt;!&ndash; 个人信息 &ndash;&gt;-->
<!--        <person-info v-show="checked === 0"></person-info>-->
<!--        &lt;!&ndash; 费用中心 &ndash;&gt;-->
<!--        <cost ref="cost" v-show="checked === 1"></cost>-->
        <!-- 订单状态 -->
        <person-order
          ref="order"
          v-show="checked === 1"
          @jumpNav="orderCome"
        ></person-order>
        <person-order
            ref="order"
            v-show="checked === 2 "
            @jumpNav="orderCome"
        ></person-order>
        <person-order
            ref="order"
            v-show="checked === 3 "
            @jumpNav="orderCome"
        ></person-order>
        <nonstandard
            ref="nonstandard"
            v-show="checked === 4"
        ></nonstandard>

<!--        &lt;!&ndash; 投诉评价 &ndash;&gt;-->
<!--        <evaluate ref="luate" v-show="checked === 3"></evaluate>-->
<!--        &lt;!&ndash; 会员管理 &ndash;&gt;-->
<!--        <members ref="members" v-show="checked === 4"></members>-->
<!--        &lt;!&ndash; 询价管理 &ndash;&gt;-->
<!--        <inquiry ref="inquiry" v-show="checked === 5"></inquiry>-->
      </div>
    </div>
  </div>
</template>

<script>
import personInfo from "../../components/personal/info";
import cost from "../../components/personal/cost";
import personOrder from "../../components/personal/order";
import evaluate from "../../components/personal/evaluate";
// import { getusername } from "../../api/myAuth";
import members from "../../components/personal/members.vue";
import inquiry from "@/components/personal/inquiry";
import nonstandard from "@/components/Goods/nonStandard.vue";
export default {
  name: "Personal",
  components: {
    personInfo,
    cost,
    personOrder,
    evaluate,
    members,
    inquiry,
    nonstandard
  },
  data() {
    return {
      checked: 1,
      nav: [
        // {
        //   id: 0,
        //   text: "会员信息",
        // },
        // {
        //   id: 1,
        //   text: "费用中心",
        // },
        {
          id: 1,
          text: "订单中心",
        },


        // {
        //   id: 2,
        //   text: "发票申请记录",
        // },
        {
          id: 3,
          text: "发票申请",
        },

        {
          id: 4,
          text: "非标产品",
        },
        // {
        //   id: 3,
        //   text: "售后服务",
        // },
        // {
        //   id: 4,
        //   text: "客户管理",
        // },
        // {
        //   id: 5,
        //   text: "询价记录",
        // },
      ],
      userType: 0,
      isInvoice: 2,
    };
  },
  computed: {
    tabList() {
      let obj = JSON.parse(window.sessionStorage.getItem("currentInfo"));
      this.isInvoice   = window.sessionStorage.getItem("customer")? JSON.parse(window.sessionStorage.getItem("customer")).isInvoice:'2';
      this.isInvoice = this.isInvoice == null?'2': this.isInvoice;
      obj.userType = (obj.userType == null?0:obj.userType);
      if(obj.userType  == 0 && this.isInvoice  == 2){
        return this.nav.slice(0, 1)
      } else if(obj.userType  == 0 && this.isInvoice  == 1){
        return this.nav.slice(0, 2)
      }  else  if(obj.userType  >= 1) {
          return this.nav
      }
      console.log('this.nav',this.nav)
    },
  },
  created() {
    this.isInvoice   = window.sessionStorage.getItem("customer")? JSON.parse(window.sessionStorage.getItem("customer")).isInvoice:'2';
    let userObj = JSON.parse(window.sessionStorage.getItem("userInfo"));
    if (userObj === null) {
      // this.$message.warning("请先登录！");
      this.$router.push({ path: "/login" });
      return;
    }
    // let obj = JSON.parse(window.sessionStorage.getItem("currentInfo"));
    // if (obj) {
    //   this.userType = obj.userType;
    //   if (this.userType !== 0) {
    //     this.nav[3].text = "客户投诉";
    //   }
    // }
    console.log(this.$route.params.checked);
    let id = this.$route.params.checked;
    let jump = this.$route.params.jump; // 头部所有订单跳转

    if (id) {
      this.checked = id;
    }
    if (jump) {
      this.checked = jump;
    }
  },
  mounted() {
    if (this.checked === 2) {
      console.log("执行了跳转");
      // this.$refs.order.init();
    }
  },
  methods: {
    // 投诉跳转
    orderCome() {
      console.log("触发了父组件事件");
      this.checked = 3;
      this.$refs.luate.getcomplaint();
    },
    // 动态添加下标
    changes(item) {
      this.checked = item.id;
      if(this.checked !== 4){
        this.$refs.order.init( this.checked);
      }



      // if (item.id === 1) {
      //   this.$refs.cost.getUserInfo();
      // }
      // if (item.id === 2) {
      //   this.$refs.order.init();
      // }
      // if (item.id === 3) {
      //   this.$refs.luate.getcomplaint();
      // }
      // if (item.id === 4) {
      //   console.log("执行了这里");
      //   this.$refs.members.init();
      // }
      // if (item.id === 5) {
      //   this.$refs.inquiry.init();
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.personal {
  width: 100%;
 // background-color: #f8f8f8;
  .nav {
    width: 100%;
    background-color: #0289f2;
    .nav-top {
      display: flex;
      li {
        width: 160px;
        font-size: 16px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        color: #fff;
        position: relative;
        cursor: pointer;
        .checked {
          width: 12px;
          height: 8px;
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          margin: 0 auto;
          background: url("../../static/imgs/icon_triangle_white.png") no-repeat
            center;
          background-size: cover;
        }
      }
      .yinyou {
        width: 160px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background-color: #047bd7;
        // display: flex;
        // justify-content: center;
        // align-items: center;
        // .img {
        //   display: block;
        //   width: 98px;
        //   height: 23px;
        //   background: url("../../static/imgs/personalCenter/mineyy.png")
        //     no-repeat center;
        // }
        .myMember {
          display: block;
          font-size: 20px;
          font-weight: 700;
          color: #fff;
        }
      }
    }
  }
  .ban {
    width: 1500px;
    margin: 0 auto;
    font-size: 16px;
  }
}
</style>
